import { render } from "./TaggedText.vue?vue&type=template&id=0b291cea&scoped=true"
const script = {}

import "./TaggedText.vue?vue&type=style&index=0&id=0b291cea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b291cea"]])

export default __exports__